import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function scrollToId(id, offset = 32) {
  if (!id) return;

  const el = document.getElementById(id);
  if (!el) {
    console.warn(`No element found with id="${id}"`);
    return;
  }

  const rect = el.getBoundingClientRect();
  const scrollTop = rect.top + window.pageYOffset;

  window.scrollTo({
    top: scrollTop - offset,
    behavior: "smooth",
  });
}

export function scrollToId2(id) {
  if (!id) return;

  document
    .getElementById(id)
    .scrollIntoView({ behavior: "smooth", alignToTop: true });
}

export function scrollToId3(id) {
  if (!id) return;
  const rect = document.getElementById(id).getBoundingClientRect();
  window.scrollTo({ top: window.scrollY + rect.top - 130, behavior: "smooth" });
}

export async function useScrollToQueryElement(checkNavMenu) {
  const location = useLocation();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const targetId = params.get("scroll");
      if (!targetId) return;

      scrollToId3(targetId);
    })();
  }, [location.search]);
}
